import { View, Text, Dimensions, Image, Platform } from "react-native";
import React, { useRef } from "react";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButton,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useEffect } from "react";
import { babyBoy, babyGirl, newChild, width } from "../../imports";
import {
  danger,
  femaleColor,
  gray,
  maleColor,
  primary,
  white,
} from "../../colors";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import UploadSection from "../../components/custom/UploadSection";
import MyButton from "../../components/custom/MyButton";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import addChild from "../../api/post/addChild";
import { refresh } from "../../redux/main/mainAction";
import editCurrentChild from "../../api/post/editCurrentChild";
import childDetail from "../../api/post/childDetail";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import * as ImagePicker from "expo-image-picker";
import editCurrentChildPicture from "../../api/post/editCurrentChildPicure";
import inactiveChild from "../../api/post/inactiveChild";

export default function EditChild({ route }) {
  const navigation = useNavigation();
  const { params } = route;
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [canAdded, nowCanAdded] = useState(false);
  const [input, setInput] = useState({
    name: null,
    lastName: null,
    birthDay: null,
    birthMonth: null,
    birthYear: null,
    pregnancyDue: null,
    childNo: null,
    height: null,
    weightGrams: null,
    weightKilos: null,
  });
  useEffect(() => {
    childDetail(params.id)
      .then(({ data }) => {
        //console.log(data);
        if (data.status === 200) {
          setInput((prev) => ({
            ...prev,
            ...data.data,
            birthDay: data.data.dateBirthHejri.slice(8, 10),
            birthMonth: data.data.dateBirthHejri.slice(5, 7),
            birthYear: data.data.dateBirthHejri.slice(0, 4),
            height: data.data.fHeight !== null ? "" + data.data.fHeight : null,
            pregnancyDue: "" + data.data.pregnancyWeek,
            childNo: "" + data.data.chlidrenNO,
            weightGrams: data.data.fWeight
              ? "" + (data.data.fWeight % 1000)
              : null,
            weightKilos: data.data.fWeight
              ? "" + Math.floor(data.data.fWeight / 1000)
              : null,
          }));
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);

  const changeHandler = (event) => {
    setImage(event.target.files[0]);
    uploadImage(event.target.files[0]);
  };
  const fileInput = useRef(null);
  const selectFile = () => {
    fileInput.current.click();
  };
  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });
    if (!result.canceled) {
      setImage(result);
      uploadImage(result);
    }
  };

  const uploadImage = (image) => {
    editCurrentChildPicture(params.id, image).then(({ data }) => {
      if (data.status === 200) {
        childDetail(params.id)
          .then(({ data }) => {
            // console.log(data);
            if (data.status === 200) {
              setInput((prev) => ({
                ...prev,
                picURL: data.data.picURL,
              }));
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      }
    });
  };

  const addNewChild = () => {
    setLoading(true);
    let totalWeight = null;
    let height = null;
    if (
      (input.weightGrams === "" ||
        input.weightGrams === null ||
        input.weightGrams.length === 0) &&
      (input.weightKilos === "" ||
        input.weightKilos === null ||
        input.weightKilos.length === 0)
    ) {
      //console.log("here we are");
      // setLoading(false);
      // return;
    } else {
      let kilo = 0;
      let gram = 0;
      kilo = +input.weightKilos;
      gram = +input.weightGrams;
      if (
        input.weightGrams === "" ||
        input.weightGrams === null ||
        input.weightGrams.length === 0
      ) {
        gram = 0;
      }
      if (
        input.weightKilos === "" ||
        input.weightKilos === null ||
        input.weightKilos.length === 0
      ) {
        kilo = 0;
      }
      totalWeight = kilo * 1000 + gram;
    }
    //console.log("heighti:", input.height);
    if (
      input.height === "" ||
      input.height == null ||
      input.height.length === 0
    ) {
      //console.log("h");
    } else {
      //console.log(input.height);
      height = +input.height;
    }
    editCurrentChild(
      params.id,
      input.name,
      input.lastName,
      `${input.birthYear}-${
        input.birthMonth < 10 ? "0" + input.birthMonth : input.birthMonth
      }-${input.birthDay < 10 ? "0" + input.birthDay : input.birthDay}`,
      parseInt(input.pregnancyDue),
      params.gender === "male" ? "boy" : "girl",
      parseInt(input.childNo),
      totalWeight,
      height,
      main.rtl ? true : false
    )
      .then(({ data }) => {
        setLoading(false);
       
        if (data.status === 200) {
          dispatch(refresh());
          Toast.show({
            type: "success",
            text1: translate("changes successfully saved"),
          });
          setTimeout(() => navigation.pop(1), 1000);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const deleteChild = () => {
    setDeleteLoading(true);
    inactiveChild(params.id).then(({ data }) => {
      setDeleteLoading(false);
   
      if (data.status === 200) {
        navigation.pop(1);
      }
    });
  };
  useEffect(() => {
    let allCompleted = true;
    Object.keys(input).forEach((key, index) => {
      //console.log(key, input[key]);
      if (input[key] === null || input[key].length === 0 || input[key] === "") {
        if (
          key === "childNo" ||
          key === "pregnancyDue" ||
          key === "birthYear" ||
          key === "birthMonth" ||
          key === "birthDay" ||
          key === "lastName" ||
          key === "name"
        ) {
          allCompleted = false;
        }
      }
    });
    if (allCompleted) {
      nowCanAdded(true);
    } else {
      nowCanAdded(false);
    }
  }, [input]);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#EAFDDB"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);
  return (
    <KeyboardAwareScrollView
      keyboardShouldPersistTaps="handled"
      enableOnAndroid
      extraHeight={100}
      style={{ width: width }}
      contentContainerStyle={{ width: width }}
    >
      <View
        style={{
          width: width,
          alignItems: "center",
          flex: 1,
        }}
      >
        <View style={{ alignItems: "center", width: "100%" }}>
          <View
            style={{
              height: Dimensions.get("window").height,
              marginTop: -1 * Dimensions.get("window").height,

              width: width,
            }}
          ></View>
          <View style={{ alignItems: "center" }}>
            <View style={{}}>
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  width: Dimensions.get("screen").width,
                  minHeight: 100,
                  flexDirection: "row",
                  paddingHorizontal: 10,
                }}
              >
                <View style={{ flex: 5 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      marginHorizontal: 10,
                      alignItems: "center",
                    }}
                  >
                    <MyText
                      style={{
                        fontSize: 24,
                        marginHorizontal: 2,
                        color: "#504E4E",
                      }}
                    >
                      {translate("edit information")}
                    </MyText>
                    <MyText
                      style={{
                        fontSize: 24,
                        marginHorizontal: 2,
                        color:
                          params?.gender === "male" ? maleColor : femaleColor,
                      }}
                    >
                      {`${input.name}`}
                    </MyText>
                  </View>
                  <View
                    direction={main.rtl ? "rtl" : "ltr"}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      marginVertical: 15,
                    }}
                  >
                    {Platform.OS === "web" ? (
                      <input
                        type="file"
                        style={{ display: "none" }}
                        ref={fileInput}
                        onChange={changeHandler}
                      />
                    ) : null}
                    <TouchableOpacity
                      onPress={Platform.OS === "web" ? selectFile : pickImage}
                      style={{
                        padding: 2,

                        height: 100,
                        width: 100,
                        borderRadius: 50,
                        backgroundColor: params?.gender
                          ? maleColor
                          : femaleColor,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: 5,
                      }}
                    >
                      <Image
                        defaultSource={
                          params?.gender === "male" ? babyBoy : babyGirl
                        }
                        style={{
                          width: 68,
                          height: 68,
                          borderRadius: 34,
                        }}
                        source={
                          input.picURL === null
                            ? params?.gender === "male"
                              ? babyBoy
                              : babyGirl
                            : { uri: input.picURL }
                        }
                        resizeMode="contain"
                      />
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={{ width: "85%" }}>
          <MyInputWithLabel
            value={input.name}
            noPlaceHolder={true}
            name="name"
            setInput={setInput}
            text={translate(
              params?.gender === "male" ? "your son name" : "your daughter name"
            )}
            style={{ marginVertical: 10, width: "100%" }}
            borderStyle={{
              borderColor: params?.gender === "male" ? maleColor : femaleColor,
            }}
            labelStyle={{
              color: params?.gender === "male" ? maleColor : femaleColor,
            }}
          />
          <MyInputWithLabel
            value={input.lastName}
            noPlaceHolder={true}
            name="lastName"
            setInput={setInput}
            text={translate(
              params?.gender === "male"
                ? "your son last name"
                : "your daughter last name"
            )}
            style={{ marginVertical: 10, width: "100%" }}
            borderStyle={{
              borderColor: params?.gender === "male" ? maleColor : femaleColor,
            }}
            labelStyle={{
              color: params?.gender === "male" ? maleColor : femaleColor,
            }}
          />
          <MyText
            style={{
              color: params?.gender === "male" ? maleColor : femaleColor,
            }}
          >
            {translate(
              params?.gender === "male"
                ? "your son birth date"
                : "your daughter birth date"
            )}
          </MyText>
          <View style={{ marginVertical: 15, flexDirection: "row" }}>
            <View
              style={{ alignItems: "center", flex: 1, marginHorizontal: 5 }}
            >
              <MyText>{translate("day")}</MyText>
              <MyInputWithLabel
                value={input.birthDay}
                keyboardType="numeric"
                borderStyle={{
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                }}
                setInput={setInput}
                name="birthDay"
              />
            </View>
            <View
              style={{ alignItems: "center", flex: 1, marginHorizontal: 5 }}
            >
              <MyText>{translate("month")}</MyText>
              <MyInputWithLabel
                value={input.birthMonth}
                keyboardType="numeric"
                borderStyle={{
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                }}
                setInput={setInput}
                name="birthMonth"
              />
            </View>

            <View
              style={{ alignItems: "center", flex: 1, marginHorizontal: 5 }}
            >
              <MyText>{translate("year")}</MyText>
              <MyInputWithLabel
                value={input.birthYear}
                keyboardType="numeric"
                borderStyle={{
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                }}
                setInput={setInput}
                name="birthYear"
              />
            </View>
          </View>
          <View>
            <MyText
              style={{
                color: params?.gender === "male" ? maleColor : femaleColor,
              }}
            >
              {translate("pregnancy due date")}
            </MyText>
            <View
              style={{
                flexDirection: "row",
                width: width / 2,
                borderRadius: 15,
                borderWidth: 1,
                borderColor:
                  params?.gender === "male" ? maleColor : femaleColor,
                alignItems: "center",
                overflow: "hidden",
                paddingHorizontal: 5,
              }}
            >
              <View style={{ flex: 1, height: 50 }}>
                <MyInputWithLabel
                  value={input.pregnancyDue}
                  keyboardType="numeric"
                  borderStyle={{
                    marginTop: -18,
                    borderWidth: 0,
                  }}
                  setInput={setInput}
                  name="pregnancyDue"
                />
              </View>

              <View
                style={{
                  height: 20,
                  width: 1,
                  backgroundColor: gray,
                  marginHorizontal: 5,
                }}
              ></View>
              <MyText style={{}}>{translate("week")}</MyText>
            </View>
            <View style={{ marginTop: 20, width: "100%" }}>
              <MyText
                style={{
                  color: params?.gender === "male" ? maleColor : femaleColor,
                }}
              >
                {translate("your child birth weight")}
              </MyText>
              <View style={{ marginTop: 20, flexDirection: "row" }}>
                <View style={{ alignItems: "center" }}>
                  <MyText>{translate("kilograms")}</MyText>
                  <MyInputWithLabel
                    value={input.weightKilos}
                    borderStyle={{
                      borderColor:
                        params?.gender === "male" ? maleColor : femaleColor,
                    }}
                    name="weightKilos"
                    keyboardType="number-pad"
                    style={{ width: width / 3 }}
                    setInput={setInput}
                    maxLength={3}
                  />
                </View>
                <View style={{ alignItems: "center", marginHorizontal: 10 }}>
                  <MyText>{translate("grams")}</MyText>
                  <MyInputWithLabel
                    value={input.weightGrams}
                    borderStyle={{
                      borderColor:
                        params?.gender === "male" ? maleColor : femaleColor,
                    }}
                    name="weightGrams"
                    keyboardType="number-pad"
                    style={{ width: width / 3 }}
                    setInput={setInput}
                    maxLength={3}
                  />
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20, width: "100%" }}>
              <MyText
                style={{
                  color: params?.gender === "male" ? maleColor : femaleColor,
                }}
              >
                {translate("your child birth height")}
              </MyText>
              <View
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View style={{ alignItems: "center" }}>
                  <MyInputWithLabel
                    value={input.height}
                    borderStyle={{
                      borderColor:
                        params?.gender === "male" ? maleColor : femaleColor,
                    }}
                    name="height"
                    keyboardType="number-pad"
                    style={{ width: width / 3 }}
                    setInput={setInput}
                    maxLength={3}
                  />
                </View>
                <MyText style={{ marginHorizontal: 10 }}>
                  {translate("cm")}
                </MyText>
              </View>
            </View>
            <MyInputWithLabel
              value={input.childNo}
              keyboardType="numeric"
              noPlaceHolder={true}
              name="childNo"
              setInput={setInput}
              text={translate("children birth order")}
              style={{ marginVertical: 10, width: "40%" }}
              borderStyle={{
                borderColor:
                  params?.gender === "male" ? maleColor : femaleColor,
              }}
              labelStyle={{
                color: params?.gender === "male" ? maleColor : femaleColor,
              }}
            />
          </View>
        </View>
        {/* <View style={{ width: "80%", alignItems: "center" }}>
          <UploadSection
            setImage={setImage}
            textColor={params?.gender === "male" ? maleColor : femaleColor}
            borderColor={params?.gender === "male" ? maleColor : femaleColor}
          />
        </View> */}
        <View style={{ width: "90%" }}>
          <MyButton
            onPress={canAdded ? addNewChild : null}
            loading={loading}
            text={translate("save changes")}
            style={{
              backgroundColor: canAdded
                ? params?.gender === "male"
                  ? maleColor
                  : femaleColor
                : "#ddd",
              paddingVertical: 10,
            }}
            textStyle={{ fontSize: 20 }}
          />
        </View>
        <View style={{ width: "90%", marginTop: 20 }}>
          <MyButton
            onPress={deleteChild}
            loading={deleteLoading}
            text={translate("delete child")}
            style={{
              backgroundColor: danger,
              paddingVertical: 10,
            }}
            textStyle={{ fontSize: 20 }}
          />
        </View>
        <View style={{ height: 140 }}></View>
      </View>
    </KeyboardAwareScrollView>
  );
}
